import classNames from 'classnames';
import { Card } from '@mui/material';
import { CardRootProps } from './CardRoot.types';

import styles from './CardRoot.module.css';

export const CardRoot = ({ children, isNew, className }: CardRootProps) => (
  <Card
    data-testid="Card"
    className={classNames(styles.cardRoot, {
      [styles.isNew]: isNew,
      [className!]: className !== undefined,
    })}
    sx={{ borderRadius: 5 }}
  >
    {children}
  </Card>
);
